import React, { Component } from 'react';
import Config from './Config';
import { Scrollbars } from 'react-custom-scrollbars';
import './css/Dashboard.css';
import FX from './functions/functions';
import Modal from './Modal';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip } from 'recharts';
class Dashboard extends Component {
  confirmInterstitial = (id) => {
    console.log(id);

    FX.load(this.props.root,'interstitial/confirm' , (res, i) => {
      console.log(res);
      if(res.success){
          console.log(this.props.root.setState({interstitial : res.interstitial}));
      }
    }, {method:'POST',data:{target : id}});


  }
  render(){
      console.log(this.props.root.state.current_customer.dashboard);
      var data = [];
      if(this.props.root.state.current_customer.dashboard){
        data = this.props.root.state.current_customer.dashboard.dailyOrders
      }
      var vesion_warn;
        console.log(Config.options);
      if(this.props.root.state.system.latest_ui > Config.options.ui_version){
        console.log(Config.options);
        vesion_warn = (
        <div className="version_warn">
            <span>A newer version exists, but you're using a cached version! Why not refresh?</span>
            <i onClick={()=>{window.location.reload(true);}} className="material-icons refreshBtn">refresh</i>
        </div>)
      }

      var graph, stockWarns, sales;
      if(data.length){
      graph = (
        <div id="GraphBox">
        <ResponsiveContainer height={400} width='100%'>
          <AreaChart data={data}
            margin={{top: 5, right: 20, left: 0, bottom: 0}}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#07a" stopOpacity={0}/>
                <stop offset="95%" stopColor="#07a" stopOpacity={1}/>
              </linearGradient>
              <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis dataKey="date"/>
            <YAxis width={32}/>
            <Tooltip/>
            <Area type="monotone" dataKey="sales" name="Orders" stroke="#07a" fill="url(#colorUv)" strokeWidth={2} reversed={true} />
          </AreaChart>
        </ResponsiveContainer>
        </div>)
        if(this.props.root.state.current_customer.dashboard.stocks.length > 0){
            stockWarns = this.props.root.state.current_customer.dashboard.stocks.map( item => {
              return (<tr  onClick={FX.navigate.bind(this.props.root, 'products'  , undefined ,'/products/'+item.id)}><td>{item.name}</td><td>{item.sku}</td><td>{item.stock}</td></tr>)
            })
            stockWarns = (<div class="h-box"><h4>Stock Alerts</h4><table className="stockTab">
                            <tr><th>Name</th><th>SKU</th><th>Stock</th></tr>
                            {stockWarns}
                          </table></div>);
        }
        sales = [];
        for(var i = 0; i < Math.min(this.props.root.state.current_customer.dashboard.sales.length, 5); i++){
          var item = this.props.root.state.current_customer.dashboard.sales[i];
          console.log(item);
          sales.push(<tr onClick={FX.navigate.bind(this.props.root, 'products'  , undefined ,'/products/'+item.id)}><td>{item.name}</td><td>{item.sku}</td><td>{item.total}</td></tr>)
        }

        sales = (<div class="h-box"><h4>Product Sales</h4><table className="salesTab">
                        <tr><th>Name</th><th>SKU</th><th>Total</th></tr>
                        {sales}
                      </table></div>);
      }


      console.log(this.props.root.state.interstitial);
      var interstitial;
      if ( this.props.root.state.interstitial && this.props.root.state.interstitial.length){
        var zen = this.props.root.state.interstitial.map(inter => {
          return (
              <div className="interstitial">
                  <div><h1>{inter.interstitial.title}</h1></div>
                  <div dangerouslySetInnerHTML={{__html: inter.interstitial.message}}  ></div>
                  <div><button onClick={this.confirmInterstitial.bind(this,inter.interstitial_target.id)} class="conf">{inter.interstitial.conf_text}</button></div>
                  <div className="tidy"/>
              </div>
          );
        })
        interstitial = (
          <Modal fs={false} title="Messages from Vdepot">
            <div>{zen}</div>
          </Modal>
        )
      }

      return (
        <div className="Dashboard">
          {vesion_warn}
          {graph}
          <div className="lists">
          <div>
            {sales}
            {stockWarns}
          </div>
          {interstitial}
          </div>
        </div>);
  }

}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/Dashboard.js